document.addEventListener("DOMContentLoaded", function () {
    const gridContainer = document.querySelector(".diamond-products-grid");
    const mainWrapper = document.querySelector(".diamond-collection-products-list");
    const extraDiv = document.querySelector(".diamond-extra-div"); // This is for mobile

    const btnGridMobile1 = document.querySelector(".icon-grid-1"); // Mobile, single column view, 1st button
    const btnGridMobile2 = document.querySelector(".icon-grid-2"); // Mobile, 2 columns, 2nd button
    const btnGridMobile3 = document.querySelector(".icon-grid-3"); // Mobile & desktop: 3 columns (desktop default active)
    const btnGrid4 = document.querySelector(".icon-grid-4");        // Only for desktop, 4 columns
    const btnList = document.querySelector(".icon-grid-list");      // List button

    const allBtns = document.querySelectorAll(".dia-short-icon-item");

    function removeActive() {
        allBtns.forEach(btn => btn.classList.remove("active"));
    }

    function hideAllLayoutDivs() {
        gridContainer.classList.remove("grid-1", "grid-2", "grid-3", "grid-4");
        mainWrapper.classList.remove("show-list");
        if (extraDiv) extraDiv.classList.remove("show-extra");
    }

    function isMobile() {
        return window.matchMedia("(max-width: 768px)").matches;
    }

    // Hide tabs section (the layout/grid select buttons) on mobile
    function updateButtonVisibility() {
        const tabsSection = document.querySelector(".diamond-grid-switch-tabs");
        if (isMobile()) {
            if (tabsSection) tabsSection.style.display = "none";
            // Optionally, hide all individual buttons as well if not using tabsSection wrapper
            if (btnGridMobile1) btnGridMobile1.style.display = "none";
            if (btnGridMobile2) btnGridMobile2.style.display = "none";
            if (btnGridMobile3) btnGridMobile3.style.display = "none";
            if (btnGrid4) btnGrid4.style.display = "none";
            if (btnList) btnList.style.display = "none";
        } else {
            if (tabsSection) tabsSection.style.display = "";
            if (btnGridMobile1) btnGridMobile1.style.display = "";
            if (btnGridMobile2) btnGridMobile2.style.display = "";
            if (btnGridMobile3) btnGridMobile3.style.display = "";
            if (btnGrid4) btnGrid4.style.display = "";
            if (btnList) btnList.style.display = "";
        }
    }

    // Function to move pagination after diamond-collection-list in list view
    function movePaginationForListView() {
        const paginationContainer = document.getElementById("diamond-pagination-controls");
        const listContainer = document.querySelector(".diamond-collection-list");

        if (paginationContainer && listContainer) {
            // Check if pagination is already after the list container
            const nextElement = listContainer.nextElementSibling;
            if (nextElement !== paginationContainer) {
                // Move pagination after the list container
                listContainer.insertAdjacentElement('afterend', paginationContainer);
            }
            paginationContainer.style.display = "flex";
        }
    }

    // Function to restore pagination to original position
    function restorePaginationPosition() {
        const paginationContainer = document.getElementById("diamond-pagination-controls");
        const productsContainer = document.querySelector(".diamond-products-grid");
        const mainWrapper = document.querySelector(".diamond-collection-products-list");

        if (paginationContainer && productsContainer) {
            // Check if pagination is inside main wrapper or after grid
            const isInList = mainWrapper && mainWrapper.classList.contains("show-list");

            if (!isInList) {
                // For grid views, pagination should be after products grid
                const productsGrid = document.querySelector(".diamond-products-grid");
                if (productsGrid && productsGrid.parentNode) {
                    const lastChild = productsGrid.parentNode.lastElementChild;
                    if (lastChild !== paginationContainer) {
                        productsGrid.insertAdjacentElement('afterend', paginationContainer);
                    }
                }
                paginationContainer.style.display = "flex";
            }
        }
    }

    // Function to refresh pagination based on current view
    function refreshPaginationForCurrentView() {
        const isMobileExtraActive = extraDiv && extraDiv.classList.contains("show-extra");
        const isListView = mainWrapper && mainWrapper.classList.contains("show-list");

        if (!isMobileExtraActive) {
            renderPaginationControls(currentTotalProductCount, PAGE_SIZE, currentPage);

            // For list view, move pagination after diamond-collection-list
            if (isListView) {
                setTimeout(() => {
                    movePaginationForListView();
                }, 100);
            } else {
                // For grid views, restore to original position
                setTimeout(() => {
                    restorePaginationPosition();
                }, 100);
            }
        } else {
            const container = document.getElementById("diamond-pagination-controls");
            if (container) {
                container.style.display = "none";
                container.innerHTML = "";
            }
        }
    }

    // --- MOBILE BUTTONS ---
    // Remove mobile switch buttons: do nothing since we are hiding the tabs and want grid-2 always
    if (!isMobile()) {
        if (btnList) {
            btnList.addEventListener("click", () => {
                removeActive();
                hideAllLayoutDivs();
                btnList.classList.add("active");
                mainWrapper.classList.add("show-list");
                // Show pagination in list view
                refreshPaginationForCurrentView();
            });
        }

        if (btnGridMobile1) {
            btnGridMobile1.addEventListener("click", () => {
                removeActive();
                hideAllLayoutDivs();
                gridContainer.classList.add("grid-1");
                btnGridMobile1.classList.add("active");
                refreshPaginationForCurrentView();
            });
        }

        if (btnGridMobile2) {
            btnGridMobile2.addEventListener("click", () => {
                removeActive();
                hideAllLayoutDivs();
                gridContainer.classList.add("grid-2");
                btnGridMobile2.classList.add("active");
                refreshPaginationForCurrentView();
            });
        }

        if (btnGridMobile3) {
            btnGridMobile3.addEventListener("click", () => {
                removeActive();
                hideAllLayoutDivs();
                gridContainer.classList.add("grid-3");
                btnGridMobile3.classList.add("active");
                refreshPaginationForCurrentView();
            });
        }

        if (btnGrid4) {
            btnGrid4.addEventListener("click", () => {
                removeActive();
                hideAllLayoutDivs();
                gridContainer.classList.add("grid-4");
                btnGrid4.classList.add("active");
                refreshPaginationForCurrentView();
            });
        }
    }

    // Set default state based on viewport
    function setDefaultState() {
        removeActive();
        hideAllLayoutDivs();
        if (isMobile()) {
            // Always set grid-2 on mobile
            gridContainer.classList.add("grid-2");
            // No buttons/tabs to show active on mobile, so skip
            refreshPaginationForCurrentView();
        } else {
            if (btnGridMobile3) {
                gridContainer.classList.add("grid-3");
                btnGridMobile3.classList.add("active");
                refreshPaginationForCurrentView();
            }
        }
    }

    // Update on load and on resize
    updateButtonVisibility();
    setDefaultState();
    window.addEventListener('resize', function () {
        updateButtonVisibility();
        setDefaultState();
    });

    // Also move pagination when DOM changes (for dynamic content)
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.addedNodes.length && mainWrapper && mainWrapper.classList.contains("show-list")) {
                setTimeout(() => {
                    movePaginationForListView();
                }, 100);
            }
        });
    });

    // Observe the main wrapper for changes
    if (mainWrapper) {
        observer.observe(mainWrapper, { childList: true, subtree: true });
    }
});


const BASE_URL = "https://back.evercutdiamond.com";

// Add these new constants for token management
const TOKEN_STORAGE_KEY = 'diamond_api_token';
const TOKEN_EXPIRY_KEY = 'diamond_token_expiry';

let cachedToken = null;
let allDiamonds = [];
let allDiamondsFullyLoaded = false;

// Pagination variables
const PAGE_SIZE = 24; // 24 products per page
let currentPage = 1;
let lastFilteredProducts = [];
let currentTotalProductCount = 0; // TRACK CURRENT TOTAL TO DISPLAY


// Check current page URL or handle
const currentPath = window.location.pathname;
const isLabGrownPage = /lab[-_ ]?grown/i.test(currentPath);

async function getToken() {
    // Check if we have a stored token
    const storedToken = localStorage.getItem(TOKEN_STORAGE_KEY);
    const tokenExpiry = localStorage.getItem(TOKEN_EXPIRY_KEY);
    const currentTime = Date.now();

    // If token exists and hasn't expired (with buffer)
    if (storedToken && tokenExpiry && currentTime < parseInt(tokenExpiry)) {
        cachedToken = storedToken;
        return cachedToken;
    }


    try {
        const res = await fetch(`${BASE_URL}/node/admin_api/generate_token`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                shop: "evercut-diamond.myshopify.com"
            })
        });

        const data = await res.json();
        const newToken = data.data.token;

        // Store token in memory
        cachedToken = newToken;

        // Store token in localStorage
        localStorage.setItem(TOKEN_STORAGE_KEY, newToken);

        // Calculate and store expiry time (assuming token valid for 1 hour)
        const expiresIn = 60 * 60 * 1000; // 1 hour in milliseconds
        const expiryTime = Date.now() + expiresIn;
        localStorage.setItem(TOKEN_EXPIRY_KEY, expiryTime.toString());


        return newToken;

    } catch (error) {
        throw error;
    }
}

// Helper function to check if token is valid
function isTokenValid() {
    const storedToken = localStorage.getItem(TOKEN_STORAGE_KEY);
    const tokenExpiry = localStorage.getItem(TOKEN_EXPIRY_KEY);

    if (!storedToken || !tokenExpiry) {
        return false;
    }

    const currentTime = Date.now();
    const expiryTime = parseInt(tokenExpiry);

    return currentTime < expiryTime;
}

// Helper to clear stored token
function clearStoredToken() {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
    localStorage.removeItem(TOKEN_EXPIRY_KEY);
    cachedToken = null;
}

// =============================================
//  loadDiamondsOnce — initial load only
// =============================================
async function loadDiamondsOnce() {
    showLoader();
    try {
        const token = await getToken();

        // Build initial query based on default filters
        const initialQuery = {
            labgrown: isLabGrownPage,
            has_image: filters["has_image"] && filters["has_image"].includes("true"),
            has_v360: filters["has_v360"] && filters["has_v360"].includes("true")
        };

        const response = await fetch(`${BASE_URL}/node/admin_api/diamonds/search`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "authentication": token
            },
            body: JSON.stringify({
                shop: "evercut-diamond.myshopify.com",
                query: initialQuery,
                offset: 0,
                order: { type: "price", direction: "ASC" }
            })
        });

        const data = await response.json();
        const items = data?.data?.items || [];
        const total = data.data.total_results;

        allDiamonds = items;
        lastFilteredProducts = items;

        // const countElement = document.querySelector(".dia-short-info__products");
        // if (countElement) {
        //     countElement.innerText = `${total} products`;
        // }
        updateCount(total);

        const paginatedItems = items.slice(0, PAGE_SIZE);

        populateEmptyFilters(items);
        renderGrid(paginatedItems);
        renderTable(paginatedItems);
        renderPaginationControls(total, PAGE_SIZE, 1);
        renderFilterTabs();

    } catch (err) {
        console.error("Diamond API error:", err);
    } finally {
        hideLoader();
    }
}

function buildApiQuery() {
    const query = {
        labgrown: isLabGrownPage,
        has_image: false,
        has_v360: false
    };

    // Add media filters from the filters object
    if (filters["has_image"] && filters["has_image"].includes("true")) {
        query.has_image = true;
    }

    if (filters["has_v360"] && filters["has_v360"].includes("true")) {
        query.has_v360 = true;
    }

    // CanadaMark eligible - sends mine_to_market: ["CANADA_MARK"]
    if (filters["mine_to_market_canada"] && filters["mine_to_market_canada"].includes("true")) {
        query.mine_to_market = ["CANADA_MARK"];
    }

    // Tracr - sends has_tracer: true
    if (filters["mine_to_market_tracr"] && filters["mine_to_market_tracr"].includes("true")) {
        query.has_tracer = true;
    }

    // SCS-007 - sends has_scs_certificate: true
    if (filters["has_scs_certificate"] && filters["has_scs_certificate"].includes("true")) {
        query.has_scs_certificate = true;
    }

    // RJC - sends rjc: true
    if (filters["rjc"] && filters["rjc"].includes("true")) {
        query.rjc = true;
    }

    const shapes = filters["diamond_shape[]"];
    if (shapes?.length) {
        query.shapes = shapes.map(s => s.toUpperCase());
    }

    const colors = filters["diamond_color[]"];
    if (colors?.length) {
        query.color = colors.map(c => c.toUpperCase());
    }

    const clarities = filters["diamond_clarity[]"];
    if (clarities?.length) {
        query.clarity = clarities.map(c => c.toUpperCase());
    }

    const cuts = filters["diamond_cut[]"];
    if (cuts?.length) {
        const cutCodeMap = {
            "Very Good": "VG", "Excellent": "EX", "Good": "GD",
            "Ideal": "ID",
            "8x": "EIGHTX",
            "Fair": "F",
            "Poor": "P"
        };
        query.cut = cuts.map(v => {
            const code = cutCodeMap[v] || v;
            return code.toUpperCase();
        });
    }

    const polish = filters["diamond_polish[]"];
    if (polish?.length) {
        query.polish = polish.map(v => v.toUpperCase());
    }

    const symmetry = filters["diamond_symmetry[]"];
    if (symmetry?.length) {
        query.symmetry = symmetry.map(v => v.toUpperCase());
    }

    const flo = filters["diamond_flouresence[]"];
    if (flo?.length) {
        query.flouresence = flo.map(v => v.toUpperCase());
    }

    const report = filters["diamond_report[]"];
    if (report?.length) {
        query.certificate_lab = report;
    }

    const carats = filters["diamond_carat[]"];
    if (carats?.length) {
        const ranges = parseCaratRanges(carats);
        if (ranges.length === 1) {
            query.sizes = [{
                from: ranges[0].min,
                to: ranges[0].max ?? 99
            }];
        } else if (ranges.length > 1) {
            query.sizes = ranges.map(range => ({
                from: range.min,
                to: range.max ?? 99
            }));
        }
    }

    const prices = filters["dollar_value[]"] || filters["price[]"];

    if (prices?.length) {
        const DOLLAR_VALUE_MAPPING = {
            "under_5000": { from: 0, to: 5000 },
            "5000_13000": { from: 5000, to: 13000 },
            "13000_20000": { from: 13000, to: 20000 },
            "20_plus": { from: 20000, to: null },
        };

        const ranges = prices.map(val => DOLLAR_VALUE_MAPPING[val]).filter(Boolean);

        if (ranges.length) {
            if (ranges.length === 1) {
                query.dollar_value = {
                    from: ranges[0].from,
                    to: ranges[0].to ?? 9999999
                };
            } else {
                const froms = ranges.map(r => r.from);
                const tos = ranges.map(r => r.to ?? 9999999);
                query.dollar_value = {
                    from: Math.min(...froms),
                    to: Math.max(...tos)
                };
            }
        }
    }

    return query;
}

// Function to sync checkboxes with filters object
function syncCheckboxesWithFilters() {
    // Sync has_image checkboxes
    const hasImageCheckboxes = document.querySelectorAll('input[name="has_image"]');
    const hasImageValue = filters["has_image"] && filters["has_image"].includes("true");
    hasImageCheckboxes.forEach(cb => {
        cb.checked = hasImageValue;
    });

    // Sync has_v360 checkboxes
    const hasV360Checkboxes = document.querySelectorAll('input[name="has_v360"]');
    const hasV360Value = filters["has_v360"] && filters["has_v360"].includes("true");
    hasV360Checkboxes.forEach(cb => {
        cb.checked = hasV360Value;
    });
}

// --- DYNAMIC FILTER BADGE SUPPORT ---

const FILTER_TITLE_MAP = {
    "diamond_shape[]": "Shape",
    "dollar_value[]": "Price",
    "diamond_carat[]": "Carat",
    "diamond_color[]": "Color",
    "diamond_clarity[]": "Clarity",
    "diamond_cut[]": "Cut",
    "diamond_symmetry[]": "Symmetry",
    "diamond_polish[]": "Polish",
    "diamond_flouresence[]": "Fluorescence",
    "diamond_report[]": "Report",
    "has_image": "Image",
    "has_v360": "Video",
    "mine_to_market_canada": "Mine to Market",
    "mine_to_market_tracr": "Tracr",
    "has_scs_certificate": "SCS-007",
    "rjc": "RJC"
};

const FILTER_VALUE_MAP = {
    "diamond_origin[]": {
        "Moissanite": "Moissanite",
        "Natural diamond": "Natural diamond"
    },
    "diamond_shape[]": {
        "oval": "OVAL",
        "round": "ROUND",
        "emerald": "EMERALD",
        "marquise": "MARQUISE",
        "radiant": "RADIANT",
        "pear": "PEAR",
        "princess": "PRINCESS",
        "cushion": "CUSHION",
        "asscher": "ASSCHER",
        "heart": "HEART",
        "square": "SQUARE",
        "oldMiner": "OLD MINER",
        "star": "STAR",
        "rose": "ROSE",
        "halfMoon": "HALF MOON",
        "cushionBrilliant": "CUSHION BRILLIANT",
        "trapezoid": "TRAPEZOID",
        "flanders": "FLANDERS",
        "briolette": "BRIOLETTE",
        "pentagonal": "PENTAGONAL",
        "hexagonal": "HEXAGONAL",
        "octagonal": "OCTAGONAL",
        "triangular": "TRIANGULAR",
        "trilliant": "TRILLIANT",
        "calf": "CALF",
        "shield": "SHIELD",
        "lozenge": "LOZENGE",
        "kite": "KITE",
        "europeanCut": "EUROPEAN CUT",
        "baguette": "BAGUETTE",
        "taperedBaguette": "TAPERED BAGUETTE",
        "bullet": "BULLET",
        "taperedBullet": "TAPERED BULLET",
        "other": "OTHER",
        "sqEmerald": "SQ. EMERALD",
        "sqRadiant": "SQ. RADIANT"
    },
    "diamond_cut[]": {
        "EX": "Excellent",
        "ID": "Ideal",
        "VG": "Very Good",
        "GD": "Good",
        "F": "Fair",
        "P": "Poor",
        "EIGHTX": "8X"
    },
    "diamond_carat[]": {},
    "diamond_color[]": {
        "D": "D",
        "E": "E",
        "F": "F",
        "G": "G",
        "H": "H",
        "I": "I",
        "J": "J",
        "K": "K",
        "L": "L",
        "M": "M",
        "ST": "ST",
        "FANCY": "FANCY",
        "N": "N",
        "NO": "NO",
        "PR": "PR",
        "SZ": "SZ",
        "OP": "OP",
        "QR": "QR",
        "UV": "UV",
        "WX": "WX",
        "XY": "XY",
        "YZ": "YZ"

    },
    "diamond_clarity[]": {
        "FL": "FL", "IF": "IF", "VVS1": "VVS1", "VVS2": "VVS2", "VS1": "VS1", "VS2": "VS2", "SI1": "SI1", "SI2": "SI2", "I1": "I1", "I2": "I2", "I3": "I3"
    },
    "diamond_flouresence[]": {
        "NON": "NON",
        "FNT": "FNT",
        "MED": "MED",
        "STG": "STG",
        "VST": "VST"
    },
    "diamond_polish[]": {
        "EX": "Excellent", "VG": "Very Good", "GD": "Good", "FR": "Fair", "P": "POOR", "ID": "Ideal"
    },
    "diamond_symmetry[]": {
        "EX": "Excellent", "VG": "Very Good", "GD": "Good", "F": "Fair", "P": "POOR", "ID": "Ideal"
    },
    "diamond_report[]": {
        "ANY_CERT": "Any cert",
        "WISE": "WISE",
        "HRD": "HRD",
        "GCAL": "GCAL",
        "EGL": "EGL",
        "DBIOD": "DBIOD",
        "GIA": "GIA",
        "IGI": "IGI",
        "GSI": "GSI",
        "SGL": "SGL",
        "AGS": "AGS",
        "EGLISR": "EGLISR",
        "NON_CERT": "Non-cert",
        "OTHER": "Supplier-cert",
        "NONE": "NONE"

    },
    "dollar_value[]": {
        "under_5000": "Under $5,000",
        "5000_13000": "$5,000 - $13,000",
        "13000_20000": "$13,000 - $20,000",
        "20_plus": "$20,000+"
    },
    "has_image": {
        "true": "yes"
    },
    "has_v360": {
        "true": "yes"
    },
    "mine_to_market_canada": {
        "true": "CanadaMark eligible"
    },
    "mine_to_market_tracr": {
        "true": "Yes"
    },
    "has_scs_certificate": {
        "true": "Yes"
    },
    "rjc": {
        "true": "Yes"
    }
};

function displayFilterValue(key, value) {
    if (FILTER_VALUE_MAP[key] && FILTER_VALUE_MAP[key][value]) return FILTER_VALUE_MAP[key][value];
    if (key === "diamond_carat[]") {
        if (value.endsWith("_plus")) {
            return value.replace("_plus", "+ ct");
        }
        const [min, max] = value.split("_");
        if (min && max) return `${min} - ${max} ct`;
    }
    return value.charAt(0).toUpperCase() + value.slice(1);
}

// update total product count format function
function formatNumberWithCommas(number) {
    return Number(number).toLocaleString('en-US');
}
// update total product count function
function updateCount(count) {
    const countElement = document.querySelector(".dia-short-info__products");
    if (countElement) {
        const formattedCount = formatNumberWithCommas(count);
        countElement.innerText = `${formattedCount} products`;
    }
}

function renderFilterTabs() {
    const badgeWrap = document.querySelector(".diamond-filters-badge-list");
    if (!badgeWrap) return;

    Array.from(badgeWrap.querySelectorAll(':scope > .diamond-filters-badge')).forEach(child => {
        badgeWrap.removeChild(child);
    });

    const filterKeys = Object.keys(filters).filter(key => filters[key] && filters[key].length);
    filterKeys.forEach(key => {
        const values = filters[key];
        if (!values || !values.length) return;

        // Special handling for media filters to show individual badges
        if (key === "has_image" || key === "has_v360" || key === "mine_to_market_tracr" || key === "has_scs_certificate" || key === "rjc") {
            values.forEach(value => {
                const title = FILTER_TITLE_MAP[key] || key;
                const label = displayFilterValue(key, value);

                const badge = document.createElement("div");
                badge.className = "diamond-filters-badge";
                badge.innerHTML = `
                    <div class="diamond-filters-badge-content">
                        <span>${escapeHtml(title)}: ${escapeHtml(label)}</span>
                    </div>
                    <div>
                        <button class="diamond-filters-badge-close" data-filter-key="${escapeHtml(key)}" data-filter-value="${escapeHtml(value)}" aria-label="Remove filter">
                            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                                <path d="M8.25 0.75L0.75 8.25M0.75 0.75L8.25 8.25" stroke="#717680" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>
                `;
                const clearAll = badgeWrap.querySelector('.diamond-filters-badge-clear-all');
                if (clearAll) {
                    badgeWrap.insertBefore(badge, clearAll);
                } else {
                    badgeWrap.appendChild(badge);
                }
            });

        }
        // Handle new Mine to Market - CanadaMark
        else if (key === "mine_to_market_canada") {
            const title = "Mine to Market";
            const label = "CanadaMark eligible";
            const badge = createFilterBadge(title, label, key, "true");
            insertBadge(badgeWrap, badge);
        }
        else {
            // Handle other filters as before (combined)
            const title = FILTER_TITLE_MAP[key] || key;
            const combinedLabel = values.map(v => escapeHtml(displayFilterValue(key, v))).join(', ');

            const badge = document.createElement("div");
            badge.className = "diamond-filters-badge";
            badge.innerHTML = `
                <div class="diamond-filters-badge-content">
                    <span>${escapeHtml(title)}: ${combinedLabel}</span>
                </div>
                <div>
                    <button class="diamond-filters-badge-close" data-filter-key="${escapeHtml(key)}" aria-label="Remove filter">
                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                            <path d="M8.25 0.75L0.75 8.25M0.75 0.75L8.25 8.25" stroke="#717680" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                </div>
            `;
            const clearAll = badgeWrap.querySelector('.diamond-filters-badge-clear-all');
            if (clearAll) {
                badgeWrap.insertBefore(badge, clearAll);
            } else {
                badgeWrap.appendChild(badge);
            }
        }

        // Add these helper functions if they don't exist
        function createFilterBadge(title, label, key, value) {
            const badge = document.createElement("div");
            badge.className = "diamond-filters-badge";
            badge.innerHTML = `
        <div class="diamond-filters-badge-content">
            <span>${escapeHtml(title)}: ${escapeHtml(label)}</span>
        </div>
        <div>
            <button class="diamond-filters-badge-close" data-filter-key="${escapeHtml(key)}" data-filter-value="${escapeHtml(value)}" aria-label="Remove filter">
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                    <path d="M8.25 0.75L0.75 8.25M0.75 0.75L8.25 8.25" stroke="#717680" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </div>
    `;
            return badge;
        }

        function insertBadge(badgeWrap, badge) {
            const clearAll = badgeWrap.querySelector('.diamond-filters-badge-clear-all');
            if (clearAll) {
                badgeWrap.insertBefore(badge, clearAll);
            } else {
                badgeWrap.appendChild(badge);
            }
        }
    });

    const clearAllWrap = document.querySelector(".diamond-filters-badge-clear-all");
    if (clearAllWrap) {
        if (filterKeys.length > 0) {
            clearAllWrap.style.display = "";
        } else {
            clearAllWrap.style.display = "none";
        }
    }
}

document.addEventListener("click", function (event) {
    const closeBtn = event.target.closest(".diamond-filters-badge-close");
    if (closeBtn) {
        const key = closeBtn.getAttribute("data-filter-key");
        if (filters[key]) {
            delete filters[key];
        }
        document.querySelectorAll(`input[name="${CSS.escape(key)}"]`).forEach(input => { input.checked = false; });
        currentPage = 1;
        renderFilterTabs();
        applyFiltersDebounced();
    }
});

document.addEventListener("DOMContentLoaded", () => {
    const clearAllBtn = document.querySelector(".diamond-filters-badge-clear-all button");
    if (clearAllBtn) {
        clearAllBtn.addEventListener("click", () => {
            Object.keys(filters).forEach(k => delete filters[k]);
            document.querySelectorAll("input[type='checkbox']").forEach(cb => cb.checked = false);
            currentPage = 1;
            renderFilterTabs();
            applyFiltersDebounced();
        });
    }
});

function renderBanner(banner, bannerIndex = 0) {
    if (!banner) return "";

    const image = banner.image?.src || banner.image || "";
    const title = banner.title || "";
    let description = banner.description || "";
    let button = banner.button || "";

    if (typeof description === "object" && description !== null) {
        description = description.text || "";
    }

    if (typeof button === "object" && button !== null) {
        const label = button.label || button.text || "";
        const url = button.url || button.link || "#";
        const target = button.target ? ` target="${button.target}"` : "";
        if (label) {
            button = `<a href="${escapeHtml(url)}"${target} class="button">${escapeHtml(label)}</a>`;
        } else {
            button = "";
        }
    }

    const uniqueClass = `diamond-banner-unique-${bannerIndex}`;

    return `
      <div id="Banner-diamond-promo-banner-${bannerIndex}" class="banner ${uniqueClass} banner--content-align-center banner--content-align-mobile-center banner--adapt banner--mobile-bottom scroll-trigger animate--fade-in">
        <div class="banner__media media scroll-trigger animate--fade-in">
          <img 
            src="${image}" 
            alt="" 
            fetchpriority="auto"
            loading="lazy"
          >
          <div class="banner__content banner__content--middle-center scroll-trigger animate--slide-in ring-remember-banner">
            <div class="banner__box content-container content-container--full-width-mobile color-scheme-1 gradient">
              <h2 class="banner__heading inline-richtext h1">
                ${escapeHtml(title)}
              </h2>
              <div class="banner__text rte body">
                <p>${description}</p>
              </div>
              ${button ? `<div class="banner__buttons">${button}</div>` : ""}
            </div>
          </div>
        </div>
      </div>
    `;
}

function formatPrice(amount, currency, country, options = {}) {
    if (typeof amount === 'string') amount = parseFloat(amount);

    let minimumFractionDigits = 0;
    let maximumFractionDigits = 2;
    if (currency === "INR" || currency === "JPY") {
        minimumFractionDigits = 0;
        maximumFractionDigits = 0;
    }

    let locale = 'en-US';
    if (country === "IN") locale = 'en-IN';
    if (country === "GB") locale = 'en-GB';
    if (country === "JP") locale = 'ja-JP';
    if (country === "DE") locale = 'de-DE';

    if (options.locale) locale = options.locale;

    try {
        return amount.toLocaleString(locale, {
            style: "currency",
            currency: currency,
            minimumFractionDigits,
            maximumFractionDigits,
        });
    } catch (err) {
        let symbol = "$";
        if (currency === "INR") symbol = "₹";
        else if (currency === "USD") symbol = "$";
        else if (currency === "GBP") symbol = "£";
        else if (currency === "EUR") symbol = "€";
        return symbol + " " + amount;
    }
}

function getCurrencyInfo() {
    let currency = "USD";
    let country = "US";

    if (window.Shopify && Shopify.currency) {
        currency = Shopify.currency.active || Shopify.currency.default || currency;
    } else if (window.CURRENCY_CODE) {
        currency = window.CURRENCY_CODE;
    }
    if (window.Shopify && Shopify.country) {
        country = Shopify.country;
    } else if (window.COUNTRY_CODE) {
        country = window.COUNTRY_CODE;
    }
    if (!country) {
        switch (currency) {
            case "INR": country = "IN"; break;
            case "USD": country = "US"; break;
            case "GBP": country = "GB"; break;
            case "EUR": country = "DE"; break;
            case "JPY": country = "JP"; break;
            default: country = "US";
        }
    }
    return { currency, country };
}


// Helper function to check if customer has specific tag
function customerHasTag(tagName) {


    const tags = window.customerData.tags;
    if (!tags || !Array.isArray(tags)) {
        return false;
    }

    return tags.some(tag => {
        if (tag.toLowerCase() === tagName.toLowerCase()) {
            return true;
        }
    });
}

// Helper function to check if price should be displayed
function shouldShowPrice() {
    if (!window.customerData) return false;

    const isLoggedIn = window.customerData.isLoggedIn;
    const priceShowSetting = window.customerData.priceshow;
    const hasRequiredTag = customerHasTag('Wholesale B2B Customer');

    return isLoggedIn || !priceShowSetting;
}

function renderGrid(products) {
    const container = document.getElementById("diamond-grid");

    // Check if no products found
    if (!products || products.length === 0) {
        container.innerHTML = `
            <div class="diamond-no-results">
                <p>No Diamonds Found</p>
            </div>
        `;
        return;
    }

    const paginatedProducts = products.slice(0, PAGE_SIZE);

    const banners = window.PAGE_BANNERS || [];

    let html = "";

    const { currency, country } = getCurrencyInfo();

    // Helper to convert price in "points" (divide by 100, format to two decimals)
    function toPoints(price) {
        if (typeof price !== "number") return price;
        return (price / 100).toFixed(2);
    }

    // Helper function to get display value for cut
    function getCutDisplayValue(cutCode) {
        const cutMapping = {
            "EX": "Excellent",
            "ID": "Ideal",
            "VG": "Very Good",
            "GD": "Good",
            "F": "Fair",
            "P": "Poor",
            "EIGHTX": "8X"
        };
        return cutMapping[cutCode] || cutCode;
    }

    // Helper function to get display value for polish
    function getPolishDisplayValue(polishCode) {
        const polishMapping = {
            "EX": "Excellent",
            "VG": "Very Good",
            "GD": "Good",
            "FR": "Fair",
            "P": "POOR",
            "ID": "Ideal"
        };
        return polishMapping[polishCode] || polishCode;
    }

    // Helper function to get display value for symmetry
    function getSymmetryDisplayValue(symmetryCode) {
        const symmetryMapping = {
            "EX": "Excellent",
            "VG": "Very Good",
            "GD": "Good",
            "F": "Fair",
            "P": "POOR",
            "ID": "Ideal"
        };
        return symmetryMapping[symmetryCode] || symmetryCode;
    }

    // Helper function to get display value for fluorescence
    function getFluorescenceDisplayValue(floCode) {
        const floMapping = {
            "NON": "NON",
            "FNT": "FNT",
            "MED": "MED",
            "STG": "STG",
            "VST": "VST"
        };
        return floMapping[floCode] || floCode;
    }

    paginatedProducts.forEach((product, index) => {
        const cert = product.diamond?.certificate || product.diamond;

        const images = [];
        if (product.diamond.image) {
            images.push(product.diamond.image);
        }
        if (product.diamond.images && Array.isArray(product.diamond.images)) {
            images.push(...product.diamond.images);
        }

        const uniqueImages = [...new Set(images)];
        const video = product.diamond.video;

        // Check if both image and video are unavailable
        const hasImages = uniqueImages.length > 0;
        const hasVideo = !!video;
        const hasNoMedia = !hasImages && !hasVideo;

        // Define fallback images
        const FALLBACK_IMAGE = 'https://cdn.shopify.com/s/files/1/0698/1114/2758/files/No_image.png?v=1778817334';
        const FALLBACK_VIDEO_IMAGE = 'https://cdn.shopify.com/s/files/1/0698/1114/2758/files/No_360_view.png?v=1778819395';

        let slidesHTML = '';

        if (hasNoMedia) {
            // Case 1: No images and no video - show both fallback images
            slidesHTML = `
        <div class="swiper-slide">
            <a href="javascript:void(0);" onclick="openProductDetail('${product.diamond.id}')">
                <img 
                    src="${FALLBACK_IMAGE}" 
                    loading="lazy"
                    alt="No image available"
                    onerror="this.onerror=null;this.src='${FALLBACK_IMAGE}';" 
                />
            </a>
        </div>
        <div class="swiper-slide">
            <a href="javascript:void(0);" onclick="openProductDetail('${product.diamond.id}')">
                <img 
                    src="${FALLBACK_VIDEO_IMAGE}" 
                    loading="lazy"
                    alt="No 360 view available"
                    onerror="this.onerror=null;this.src='${FALLBACK_VIDEO_IMAGE}';" 
                />
            </a>
        </div>
    `;
        } else if (hasImages && !hasVideo) {
            // Case 2: Has images but no video
            slidesHTML = [
                ...uniqueImages.map(img => `
            <div class="swiper-slide">
                <a href="javascript:void(0);" onclick="openProductDetail('${product.diamond.id}')">
                    <img 
                        src="${img}" 
                        loading="lazy"
                        onerror="this.onerror=null;this.src='${FALLBACK_IMAGE}';" 
                    />
                </a>
            </div>
        `),
                // Add fallback video image as second slide
                `<div class="swiper-slide">
            <a href="javascript:void(0);" onclick="openProductDetail('${product.diamond.id}')">
                <img 
                    src="${FALLBACK_VIDEO_IMAGE}" 
                    loading="lazy"
                    alt="No 360 view available"
                    onerror="this.onerror=null;this.src='${FALLBACK_VIDEO_IMAGE}';" 
                />
            </a>
        </div>`
            ].join('');
        } else if (!hasImages && hasVideo) {
            // Case 3: No images but has video
            slidesHTML = [
                // Add fallback image as first slide
                `<div class="swiper-slide">
            <a href="javascript:void(0);" onclick="openProductDetail('${product.diamond.id}')">
                <img 
                    src="${FALLBACK_IMAGE}" 
                    loading="lazy"
                    alt="No image available"
                    onerror="this.onerror=null;this.src='${FALLBACK_IMAGE}';" 
                />
            </a>
        </div>`,
                // Add actual video as second slide
                `<div class="swiper-slide diamond-swiper-slide--360 diamond-video">
            <iframe
                src="${video}"
                frameborder="0"
                scrolling="no"
                allowfullscreen
                loading="lazy"
                title="360° Diamond View"
                onclick="openProductDetail('${product.diamond.id}')"
            ></iframe>
        </div>`
            ].join('');
        } else {
            // Case 4: Has both images and video
            slidesHTML = [
                ...uniqueImages.map(img => `
            <div class="swiper-slide">
                <a href="javascript:void(0);" onclick="openProductDetail('${product.diamond.id}')">
                    <img 
                        src="${img}" 
                        loading="lazy"
                        onerror="this.onerror=null;this.src='${FALLBACK_IMAGE}';" 
                    />
                </a>
            </div>
        `),
                `<div class="swiper-slide diamond-swiper-slide--360 diamond-video">
            <iframe
                src="${video}"
                frameborder="0"
                scrolling="no"
                allowfullscreen
                loading="lazy"
                title="360° Diamond View"
                onclick="openProductDetail('${product.diamond.id}')"
            ></iframe>
        </div>`
            ].join('');
        }

        // Format price & discount in 'points', but using currency for locale
        const formattedPrice = formatPrice(
            toPoints(product.markup_price),
            currency,
            country
        );
        let formattedDiscount = "";
        const priceVal = product.markup_price;
        const discountVal = product.discount;
        if (
            typeof priceVal === "number" &&
            typeof discountVal === "number" &&
            discountVal !== 0
        ) {
            const calcOld = priceVal + discountVal;
            formattedDiscount = formatPrice(
                toPoints(calcOld),
                currency,
                country
            );
        }

        // Get display values
        const displayShape = cert.shape || '';
        const displayCut = getCutDisplayValue(cert.cut);
        const displayLab = cert.lab || '';
        let slideCount = 0;
        if (hasNoMedia) {
            slideCount = 2; // Both fallback images
        } else if (hasImages && !hasVideo) {
            slideCount = uniqueImages.length + 1; // Images + fallback video image
        } else if (!hasImages && hasVideo) {
            slideCount = 1 + 1; // Fallback image + actual video
        } else {
            slideCount = uniqueImages.length + 1; // Images + video
        }
        const hasMultipleMedia = slideCount > 1;

        html += `
        <article class="diamond-product-card" data-product-id="${product.diamond.id}">
          <div class="diamond-product-card__media" tabindex="0">

          ${hasMultipleMedia ? `
            <div class="swiper diamond-swiper">
              <div class="swiper-wrapper">
                ${slidesHTML}
              </div>
              <div class="swiper-button-next">
                <svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10" fill="#fff"/><path d="M10.74 16.28c-.19 0-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l3-3-3-3a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l3.53 3.53c.29.29.29.77 0 1.06l-3.53 3.53c-.15.15-.34.22-.53.22" fill="#121212"/></svg></div>
              <div class="swiper-button-prev">
                <svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 22c-5.523 0-10-4.477-10-10S-2.523 2 3 2s10 4.477 10 10S8.523 22 3 22" fill="#fff"/><path d="M4.26 16.28c.19 0 .38-.07.53-.22.29-.29.29-.77 0-1.06l-3-3 3-3c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0L.2 11.47c-.29.29-.29.77 0 1.06l3.53 3.53c.15.15.34.22.53.22" fill="#121212"/></svg>
              </div>
            </div>
            ` : `${slidesHTML}`}
          </div>

          <div class="diamond-product-card__meta" data-product-id="${product.diamond.id}">
            <div class="diamond-product-card__top-row">
              <span class="diamond-product-card__type">
                ${displayShape}
              </span>
              <span class="diamond-product-card__type">
                ${displayCut}
              </span>
              <span class="diamond-product-card__type">
                ${displayLab}
              </span>
            </div>
            <h3 class="diamond-product-card__title">
              ${cert.carats} Ct. ${displayShape} Diamond Super Ideal · ${cert.color} · ${cert.clarity}
            </h3>
            <div class="diamond-product-card__price">
            ${shouldShowPrice()
                ? `<span class="diamond-product-card__sale">${formattedPrice}</span>`
                : ``
            }
            </div>
            <div class="diamond-product-card-buttons">
              <button onclick="event.stopPropagation(); openProductDetail('${product.diamond.id}')">Shop Now</button>
            </div>
          </div>
        </article>
        `;

        if (index === 11 && banners[0]) {
            html += renderBanner(banners[0], 0);
        }

        if (index === 23 && banners[1]) {
            html += renderBanner(banners[1], 1);
        }
    });

    container.innerHTML = html;

    // Add click event listener only on diamond-product-card__meta elements
    document.querySelectorAll(".diamond-product-card__meta").forEach(meta => {
        meta.addEventListener("click", function (e) {
            e.stopPropagation();
            const productId = this.getAttribute("data-product-id");
            if (productId) openProductDetail(productId);
        });
    });

    // Initialize Swiper for each product card
    document.querySelectorAll(".diamond-product-card__media").forEach(media => {
        let swiperInstance = null;
        let swiperEl = media.querySelector(".diamond-swiper");

        if (swiperEl) {
            swiperEl.style.display = "block";
        }

        const pagination = swiperEl?.querySelector(".swiper-pagination");
        const nextBtn = swiperEl?.querySelector(".swiper-button-next");
        const prevBtn = swiperEl?.querySelector(".swiper-button-prev");

        if (pagination) pagination.style.display = "none";
        if (nextBtn) nextBtn.style.display = "none";
        if (prevBtn) prevBtn.style.display = "none";

        if (swiperEl && (!swiperEl.classList.contains("swiper-initialized"))) {

            swiperInstance = new Swiper(swiperEl, {
                cssMode: false,
                loop: true,
                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                },
                pagination: {
                    el: pagination,
                    clickable: true,
                },
                mousewheel: false,  // Disable mousewheel navigation completely
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                touchReleaseOnEdges: true,
                simulateTouch: true,
                allowTouchMove: true,
                slidesPerView: 1,
                spaceBetween: 0,
                threshold: 10,
                touchRatio: 0.8,
            });

            swiperInstance.on("slideChange", () => {
                const videos = swiperEl.querySelectorAll("video");
                videos.forEach(v => v.pause());
                const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
                const video = activeSlide?.querySelector("video");
                if (video) video.play();
            });
        }

        function setAriaActive(active) {
            if (pagination) {
                if (active) {
                    pagination.style.display = "";
                    pagination.style.visibility = "visible";
                    pagination.style.pointerEvents = "";
                } else {
                    pagination.style.display = "none";
                    pagination.style.visibility = "hidden";
                    pagination.style.pointerEvents = "none";
                }
            }
            if (nextBtn) {
                if (active) {
                    nextBtn.style.display = "";
                    nextBtn.style.visibility = "visible";
                    nextBtn.style.pointerEvents = "";
                } else {
                    nextBtn.style.display = "none";
                    nextBtn.style.visibility = "hidden";
                    nextBtn.style.pointerEvents = "none";
                }
            }
            if (prevBtn) {
                if (active) {
                    prevBtn.style.display = "";
                    prevBtn.style.visibility = "visible";
                    prevBtn.style.pointerEvents = "";
                } else {
                    prevBtn.style.display = "none";
                    prevBtn.style.visibility = "hidden";
                    prevBtn.style.pointerEvents = "none";
                }
            }
        }

        const productCard = media.closest('.diamond-product-card');

        productCard.addEventListener('mouseenter', () => setAriaActive(true));
        productCard.addEventListener('focus', () => setAriaActive(true));
        productCard.addEventListener('mouseleave', () => setAriaActive(false));
        productCard.addEventListener('blur', () => setAriaActive(false));

        setAriaActive(false);
    });

}
function openProductDetail(productId) {
    window.location.href = `/pages/product-detail?id=${productId}`;
}
// Redirect on ANY interaction with iframe (both click and drag)
(function () {
    function fixIframes() {
        document.querySelectorAll('.diamond-swiper-slide--360 iframe').forEach(iframe => {
            if (iframe.hasAttribute('data-fixed')) return;

            iframe.setAttribute('data-fixed', 'true');

            // Get product ID
            const productCard = iframe.closest('.diamond-product-card');
            const productId = productCard?.querySelector('.diamond-product-card__meta')?.getAttribute('data-product-id');

            if (!productId) return;

            // Redirect on any interaction (mouse down = click or drag start)
            iframe.addEventListener('mousedown', (e) => {
                e.preventDefault();
                e.stopPropagation();
                window.location.href = `/pages/product-detail?id=${productId}`;
                return false;
            });

            // Also redirect on click (as backup)
            iframe.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                window.location.href = `/pages/product-detail?id=${productId}`;
                return false;
            });

            // Keep iframe visually interactive but redirect immediately
            iframe.style.pointerEvents = 'auto';
            iframe.style.cursor = 'pointer';
        });
    }

    setInterval(fixIframes, 1000);
})();

function renderTable(products) {
    const paginatedProducts = products.slice(0, PAGE_SIZE);
    const tbody = document.getElementById("product-data-table");

    if (paginatedProducts.length === 0) {
        tbody.innerHTML = `<tr><td colspan="7" style="text-align: center; padding: 40px;">No products found</td></tr>`;
        return;
    }

    // Use same price formatting logic as in renderGrid (see line 1185-1188)
    const { currency, country } = getCurrencyInfo();

    // Helper to convert price in "points" (divide by 100, format to two decimals)
    function toPoints(price) {
        if (typeof price !== "number") return price;
        return (price / 100).toFixed(2);
    }

    tbody.innerHTML = paginatedProducts.map(p => {
        const cert = p.diamond?.certificate || p.diamond;
        // Format price using formatPrice, as used in renderGrid
        const formattedPrice = formatPrice(
            toPoints(p.markup_price),
            currency,
            country
        );
        return `
        <tr>
          <td data-label="Shape">
            <span class="diamond-results__shape">
              <span class="diamond-results__thumb-wrapper">
                <img
                  class="diamond-results__thumb"
                  src="${p.diamond.image || 'https://cdn.shopify.com/s/files/1/0698/1114/2758/files/Img_01.png'}"
                  alt="${cert.shape}"
                  loading="lazy"
                onerror="this.onerror=null; this.src='https://cdn.shopify.com/s/files/1/0698/1114/2758/files/Img_01.png';"
                >
              </span>
              <span class="diamond-results__shapeName">
                ${cert.shape}
              </span>
            </span>
           </td>
          <td data-label="Price">
            <span class="diamond-results__price">
              ${shouldShowPrice() ? `${formattedPrice}` : ``}
            </span>
           </td>
          <td data-label="Carat">
            ${cert.carats}
           </td>
          <td data-label="Cut">
            ${cert.cut || '-'}
           </td>
          <td data-label="Color">
            ${cert.color}
           </td>
          <td data-label="Clarity">
            ${cert.clarity}
           </td>
          <td class="diamond-results__actionCell" data-label=" ">
            <a class="diamond-results__btn" href="#" onclick="event.stopPropagation(); openProductDetail('${p.diamond.id}')">
              Shop Now
            </a>
           </td>
         </tr>
      `;
    }).join("");

    const banners = window.PAGE_BANNERS || [];
    const bannerContainer = document.getElementById("diamond-table-banners");
    if (bannerContainer) {
        let bannerHTML = "";
        if (banners[0]) bannerHTML += renderBanner(banners[0], 0);
        if (banners[1]) bannerHTML += renderBanner(banners[1], 1);
        bannerContainer.innerHTML = bannerHTML;
    }
}

// filters state
const filters = {};
let debounceTimer;

// Initialize media filters to true by default
filters["has_image"] = ["true"];
filters["has_v360"] = ["true"];

function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, (m) => ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        "\"": "&quot;",
        "'": "&#039;"
    }[m]));
}

function getCert(product) {
    return product?.diamond?.certificate || product?.diamond || {};
}

function getMineOfOrigin(product) {
    const mine = product?.diamond?.mine_of_origin ?? product?.diamond?.certificate?.mine_of_origin ?? null;
    if (mine === "" || mine === undefined) return null;
    return mine;
}

function toUpperSafe(v) {
    return v === null || v === undefined ? null : String(v).toUpperCase();
}

function sortByOrder(values, order) {
    const rank = new Map(order.map((v, i) => [String(v).toUpperCase(), i]));
    return [...values].sort((a, b) => {
        const ra = rank.has(a) ? rank.get(a) : 999;
        const rb = rank.has(b) ? rank.get(b) : 999;
        if (ra !== rb) return ra - rb;
        return a.localeCompare(b);
    });
}

function getFilterBodyByTitle(titleText) {
    const titles = Array.from(document.querySelectorAll("details.diamond-filter summary .diamond-filter__title"));
    const titleEl = titles.find(el => el.textContent.trim().toLowerCase() === titleText.toLowerCase());
    if (!titleEl) return null;
    const details = titleEl.closest("details.diamond-filter");
    return details ? details.querySelector(".diamond-filter__body") : null;
}

function renderCheckboxOptions(bodyEl, inputName, values, labelFn = (v) => v) {
    if (!bodyEl) return;
    const currentHasCheckboxes = bodyEl.querySelectorAll("input[type='checkbox']").length > 0;
    if (currentHasCheckboxes) return;

    bodyEl.setAttribute("aria-hidden", "false");

    bodyEl.innerHTML = values.map(v => {
        const safeLabel = escapeHtml(labelFn(v));
        const safeValue = escapeHtml(v);
        return `
          <label class="diamond-checkbox">
            <input type="checkbox" name="${escapeHtml(inputName)}" value="${safeValue}">
            <span class="diamond-checkbox__box" aria-hidden="true"></span>
            <span class="diamond-checkbox__label">${safeLabel}</span>
          </label>
        `;
    }).join("");
}

function populateEmptyFilters(items) {
    const colors = new Set();
    const clarities = new Set();
    const floInts = new Set();
    const polishes = new Set();
    const symmetries = new Set();
    const labs = new Set();
    const carats = [];

    for (const p of items) {
        const cert = getCert(p);
        if (cert.color) colors.add(String(cert.color));
        if (cert.clarity) clarities.add(String(cert.clarity));
        if (cert.floInt) floInts.add(String(cert.floInt));
        if (cert.polish) polishes.add(String(cert.polish));
        if (cert.symmetry) symmetries.add(String(cert.symmetry));
        if (cert.lab) labs.add(String(cert.lab));
        if (cert.carats !== undefined && cert.carats !== null) {
            const n = Number(cert.carats);
            if (!Number.isNaN(n)) carats.push(n);
        }
    }

    const caratBody = getFilterBodyByTitle("Carat");
    const caratRanges = [
        { label: "0.00 - 0.49", min: 0.0, max: 0.49 },
        { label: "0.50 - 0.99", min: 0.49, max: 0.99 },
        { label: "1.00 - 1.49", min: 1.00, max: 1.49 },
        { label: "1.50 - 1.99", min: 1.50, max: 1.99 },
        { label: "2.00 - 2.49", min: 2.00, max: 2.49 },
        { label: "2.50 - 2.99", min: 2.50, max: 2.99 },
        { label: "3.00 - 3.49", min: 3.00, max: 3.49 },
        { label: "3.50 - 3.99", min: 3.50, max: 3.99 },
        { label: "4.00 - 4.49", min: 4.00, max: 4.49 },
        { label: "4.50 - 4.99", min: 4.50, max: 4.99 },
        { label: "5.00+", min: 5.00, max: null }
    ];
    if (caratBody && caratBody.querySelectorAll("input[type='checkbox']").length === 0) {
        caratBody.setAttribute("aria-hidden", "false");
        caratBody.innerHTML = caratRanges.map(r => {
            const value = r.max === null ? `${r.min}_plus` : `${r.min}_${r.max}`;
            return `
              <label class="diamond-checkbox">
                <input type="checkbox" name="diamond_carat[]" value="${escapeHtml(value)}">
                <span class="diamond-checkbox__box" aria-hidden="true"></span>
                <span class="diamond-checkbox__label">${escapeHtml(r.label)}</span>
              </label>
            `;
        }).join("");
    }

    const colorBody = getFilterBodyByTitle("Color");
    // Use *only* the values and order as in @file_context_0 (page.diamond.liquid 723-747)
    renderCheckboxOptions(
        colorBody,
        "diamond_color[]",
        [
            "D", "E", "F", "G", "H", "I", "J", "K", "L", "M",
            "ST", "FANCY", "N", "NO", "PR", "SZ", "OP", "QR", "ST", "UV", "WX", "XY", "YZ"
        ]
    );

    const clarityBody = getFilterBodyByTitle("Clarity");
    const clarityOrder = ["FL", "IF", "VVS1", "VVS2", "VS1", "VS2", "SI1", "SI2", "I1", "I2", "I3"];
    renderCheckboxOptions(clarityBody, "diamond_clarity[]", sortByOrder(Array.from(clarities).map(v => toUpperSafe(v)), clarityOrder));

    const floBody = getFilterBodyByTitle("Fluorescence");
    const floOrder = ["NON", "FNT", "MED", "STG", "VST"];
    renderCheckboxOptions(floBody, "diamond_flouresence[]", sortByOrder(Array.from(floInts).map(v => toUpperSafe(v)), floOrder));

    const polishBody = getFilterBodyByTitle("Polish");
    const polishOrder = ["EX", "VG", "GD", "Fair", "POOR", "F"];
    renderCheckboxOptions(polishBody, "diamond_polish[]", sortByOrder(Array.from(polishes).map(v => toUpperSafe(v)), polishOrder));

    const symmetryBody = getFilterBodyByTitle("Symmetry");
    const symmetryOrder = ["EX", "VG", "GD", "Fair", "POOR", "F"];
    renderCheckboxOptions(symmetryBody, "diamond_symmetry[]", sortByOrder(Array.from(symmetries).map(v => toUpperSafe(v)), symmetryOrder));

    const reportBody = getFilterBodyByTitle("Report");
    // Updated to include all report values from page.diamond.liquid (858-871)
    const reportOrder = [
        "ANY_CERT", "WISE", "NEW", "HRD", "GCAL", "EGL", "DBIOD",
        "GIA", "IGI", "GSI", "SGL", "AGS", "EGLISR", "NON_CERT", "SUPPLIER_CERT", "NONE"
    ];
    if (reportBody && reportBody.querySelectorAll("input[type='checkbox']").length === 0) {
        renderCheckboxOptions(reportBody, "diamond_report[]", sortByOrder(Array.from(labs).map(v => toUpperSafe(v)), reportOrder));
    }
}

function parseCaratRanges(selectedValues) {
    const ranges = [];
    for (const v of selectedValues) {
        const raw = String(v);
        if (raw.endsWith("_plus")) {
            const min = parseFloat(raw.replace("_plus", ""));
            if (!isNaN(min)) ranges.push({ min, max: null });
            continue;
        }
        const [minStr, maxStr] = raw.split("_");
        const min = parseFloat(minStr);
        const max = parseFloat(maxStr);
        if (!isNaN(min) && !isNaN(max)) ranges.push({ min, max });
    }
    return ranges;
}

function logActiveFiltersAndProducts(products, filtersObj) {
    let logStr = "\n------ FILTER TEST LOG ------\n";
    logStr += "Active Filters:\n";
    for (const [key, values] of Object.entries(filtersObj)) {
        if (values && values.length) {
            logStr += `  ${key}: ${JSON.stringify(values)}\n`;
        }
    }
    if (Object.keys(filtersObj).length === 0) {
        logStr += "  (No filters applied)\n";
    }
    logStr += `Products found: ${products.length}\n`;
}

// =============================================
// applyFiltersDebounced — calls API
// =============================================
function applyFiltersDebounced() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
        currentPage = 1;
        fetchDiamondsWithFilters(currentPage);
    }, 400);
}

// Delegate checkbox changes
document.addEventListener("change", (event) => {
    const input = event.target;
    if (!input || input.tagName !== "INPUT") return;
    if (input.type !== "checkbox") return;
    if (!input.name) return;

    const name = input.name;
    const value = input.value;

    if (!filters[name]) filters[name] = [];

    if (input.checked) {
        if (!filters[name].includes(value)) filters[name].push(value);
    } else {
        filters[name] = filters[name].filter(v => v !== value);
        if (filters[name].length === 0) delete filters[name];
    }

    currentPage = 1;
    renderFilterTabs();
    applyFiltersDebounced();
});

document.addEventListener("DOMContentLoaded", () => {

    // Initialize filters with default values before syncing
    if (!filters["has_image"]) filters["has_image"] = ["true"];
    if (!filters["has_v360"]) filters["has_v360"] = ["true"];

    syncCheckboxesWithFilters();

    showLoader();
    loadDiamondsOnce();
    renderFilterTabs();
    renderPaginationControls(0, PAGE_SIZE, 1);

    const refreshTokenBtn = document.createElement('button');
    refreshTokenBtn.textContent = 'Refresh Token';
    refreshTokenBtn.style.cssText = 'position:fixed; bottom:10px; right:10px; z-index:9999; padding:5px 10px; background:#007bff; color:white; border:none; border-radius:4px; cursor:pointer; font-size:12px;';
    refreshTokenBtn.onclick = () => {
        clearStoredToken();
        location.reload();
    };
});

async function addToCart(id) {
    try {
        const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                id: id,
                quantity: 1
            })
        });

        if (!response.ok) {
            const err = await response.json();
            alert(err.description || "Failed to add to cart.");
            return;
        }

        window.location.href = "/cart";

    } catch (error) {
        alert("Something went wrong. Please try again.");
    }
}

// =============================================
// PAGINATION CONTROLS - Shows for ALL views (grid and list)
// =============================================
function renderPaginationControls(totalProducts, pageSize, current) {
    // Get container or create it
    let container = document.getElementById("diamond-pagination-controls");

    if (!container) {
        container = document.createElement("div");
        container.id = "diamond-pagination-controls";
        container.className = "diamond-pagination-controls";
        const grid = document.getElementById("diamond-grid");
        if (grid && grid.parentNode) {
            grid.parentNode.insertBefore(container, grid.nextSibling);
        } else {
            const gridContainer = document.querySelector(".diamond-products-grid");
            if (gridContainer && gridContainer.parentNode) {
                gridContainer.parentNode.insertBefore(container, gridContainer.nextSibling);
            }
        }
    }

    // Clear container content
    container.innerHTML = "";

    // Check mobile extra view (only hide for mobile extra view)
    const extraDiv = document.querySelector(".diamond-extra-div");
    const isMobileExtraView = extraDiv && extraDiv.classList.contains("show-extra");

    // Hide pagination only for mobile extra view
    if (isMobileExtraView) {
        container.style.display = "none";
        return;
    }

    // Calculate total pages
    const totalPages = Math.ceil(totalProducts / pageSize);

    // Hide pagination if no products or only 1 page
    if (!totalProducts || totalProducts === 0 || isNaN(totalProducts) || totalPages <= 1) {
        container.style.display = "none";
        return;
    }

    // Show pagination for all views (grid and list)
    container.style.display = "flex";

    // Helper to scroll to top after page change
    function scrollToTopAfterPagination() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }

    // Previous button
    const prevBtn = document.createElement("button");
    prevBtn.innerText = "Prev";
    prevBtn.disabled = current <= 1;
    prevBtn.className = "diamond-pagination-prev";
    if (prevBtn.disabled) {
        prevBtn.classList.add("disabled");
    }
    prevBtn.onclick = function () {
        if (currentPage > 1) {
            currentPage--;
            fetchDiamondsWithFilters(currentPage);
            scrollToTopAfterPagination();
        }
    };
    container.appendChild(prevBtn);

    // Page numbers - show up to 5 pages
    let start = Math.max(1, current - 2);
    let end = Math.min(totalPages, current + 2);

    // Adjust if we're near the beginning
    if (current <= 3) {
        end = Math.min(totalPages, 5);
    }
    // Adjust if we're near the end
    if (current >= totalPages - 2) {
        start = Math.max(1, totalPages - 4);
    }

    // Add first page button with ellipsis if needed
    if (start > 1) {
        const firstBtn = document.createElement("button");
        firstBtn.innerText = "1";
        firstBtn.className = "diamond-pagination-btn";
        firstBtn.onclick = function () {
            currentPage = 1;
            fetchDiamondsWithFilters(currentPage);
            scrollToTopAfterPagination();
        };
        container.appendChild(firstBtn);

        // if (start > 2) {
        //     const ellipsis = document.createElement("span");
        //     ellipsis.innerText = "...";
        //     ellipsis.className = "diamond-pagination-ellipsis";
        //     container.appendChild(ellipsis);
        // }
    }

    // Page number buttons - active button is NOT disabled, only styled
    // for (let i = start; i <= end; i++) {
    //     const btn = document.createElement("button");
    //     btn.innerText = `${i}`;
    //     // Active button is NOT disabled - it remains clickable but has active styling
    //     btn.disabled = false;
    //     btn.className = i === current ? "diamond-pagination-btn diamond-pagination-btn--active" : "diamond-pagination-btn";
    //     btn.onclick = function () {
    //         if (i !== currentPage) {
    //             currentPage = i;
    //             fetchDiamondsWithFilters(currentPage);
    //             scrollToTopAfterPagination();
    //         }
    //     };
    //     container.appendChild(btn);
    // }

    // Add last page button with ellipsis if needed
    if (end < totalPages) {
        // if (end < totalPages - 1) {
        //     const ellipsis = document.createElement("span");
        //     ellipsis.innerText = "...";
        //     ellipsis.className = "diamond-pagination-ellipsis";
        //     container.appendChild(ellipsis);
        // }
        // const lastBtn = document.createElement("button");
        // lastBtn.innerText = `${totalPages}`;
        // lastBtn.className = "diamond-pagination-btn";
        // lastBtn.onclick = function () {
        //     if (totalPages !== currentPage) {
        //         currentPage = totalPages;
        //         fetchDiamondsWithFilters(currentPage);
        //         scrollToTopAfterPagination();
        //     }
        // };
        // container.appendChild(lastBtn);
    }

    // Next button
    const nextBtn = document.createElement("button");
    nextBtn.innerText = "Next";
    nextBtn.disabled = current >= totalPages;
    nextBtn.className = "diamond-pagination-next";
    if (nextBtn.disabled) {
        nextBtn.classList.add("disabled");
    }
    nextBtn.onclick = function () {
        if (currentPage < totalPages) {
            currentPage++;
            fetchDiamondsWithFilters(currentPage);
            scrollToTopAfterPagination();
        }
    };
    container.appendChild(nextBtn);
}

// ====== Loader Helpers ======
function showLoader() {
    const overlay = document.getElementById('overlay');
    if (overlay) overlay.style.display = 'flex';
}
function hideLoader() {
    const overlay = document.getElementById('overlay');
    if (overlay) overlay.style.display = 'none';
}

// --- SORTING FUNCTIONALITY FOR PRICE HIGH TO LOW & LOW TO HIGH ---
let currentSortType = "price";
let currentSortDirection = "ASC";

document.addEventListener("DOMContentLoaded", function () {
    const sortSelect = document.getElementById("price-sorting");
    if (sortSelect) {
        sortSelect.addEventListener("change", function () {
            const value = sortSelect.value;

            if (value === "low") {
                currentSortType = "price";
                currentSortDirection = "ASC";
            } else if (value === "high") {
                currentSortType = "price";
                currentSortDirection = "DESC";
            } else {
                currentSortType = "price";
                currentSortDirection = "ASC";
            }

            currentPage = 1;
            fetchDiamondsWithFilters(currentPage);
        });
    }
});

// Main fetch function with sorting
fetchDiamondsWithFilters = async function (page = 1) {
    showLoader();
    try {
        const token = await getToken();
        const query = buildApiQuery();
        const offset = (page - 1) * PAGE_SIZE;


        const response = await fetch(`${BASE_URL}/node/admin_api/diamonds/search`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "authentication": token
            },
            body: JSON.stringify({
                shop: "evercut-diamond.myshopify.com",
                query,
                offset,
                order: { type: currentSortType, direction: currentSortDirection }
            })
        });

        const data = await response.json();

        const items = data?.data?.items || [];
        // const total = data?.data?.total ?? data?.data?.total_count ?? items.length;
        const total = data.data.total_results;

        lastFilteredProducts = items;
        allDiamonds = items;

        currentTotalProductCount = total;

        const paginatedItems = items.slice(0, PAGE_SIZE);

        renderGrid(paginatedItems);
        renderTable(paginatedItems);
        updateCount(total);
        renderPaginationControls(total, PAGE_SIZE, page);
        renderFilterTabs();

    } catch (error) {
        console.error("Fetch error:", error);
    } finally {
        hideLoader();
    }
}
function fix360IframeDisplay() {
    document.querySelectorAll('.diamond-swiper-slide--360 iframe').forEach((iframe) => {



        const slideWrapper = iframe.closest('.diamond-swiper-slide--360');
        const mediaWrapper = iframe.closest('.diamond-product-card__media');

        // Get the actual card media size
        const cardWidth = mediaWrapper?.offsetWidth || 300;
        const cardHeight = mediaWrapper?.offsetHeight || 300;

        // loupe360 internal canvas: 758x596 scaled to ~635x500 (scale 0.838)
        // iframe container (.aws_wrapper) is 500x500
        const IFRAME_INTERNAL = 500;
        const scale = cardWidth / IFRAME_INTERNAL;

        // --- Wrapper: clip overflow, exact card size ---
        if (slideWrapper) {
            slideWrapper.style.cssText = `
                overflow: hidden;
                position: relative;
                width: ${cardWidth}px;
                height: ${cardHeight}px;
                display: block;
            `;
        }

        // --- iframe: scale from top-left, no offset ---
        iframe.style.cssText = `
            width: ${IFRAME_INTERNAL}px;
            height: ${IFRAME_INTERNAL}px;
            border: none;
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            transform: scale(${scale});
            transform-origin: top left;
            pointer-events: all;
            overflow: hidden;
        `;

        function scaleToFit() {
            const w = mediaWrapper?.offsetWidth || 300;
            const h = mediaWrapper?.offsetHeight || 300;
            const s = Math.min(w / IFRAME_INTERNAL, h / IFRAME_INTERNAL);

            iframe.style.transform = `scale(${s})`;

            if (slideWrapper) {
                slideWrapper.style.width = `${w}px`;
                slideWrapper.style.height = `${h}px`;
            }
        }

        iframe.addEventListener('load', () => setTimeout(scaleToFit, 100));
        window.addEventListener('resize', scaleToFit);

        scaleToFit();
    });
}


// =============================================
// Patch renderGrid
// =============================================
(function patchRenderGrid() {
    const _orig = window.renderGrid;
    if (typeof _orig !== 'function') return;

    window.renderGrid = function (...args) {
        _orig.apply(this, args);
        setTimeout(fix360IframeDisplay, 500);
    };
})();


// =============================================
// Hook Swiper slideChange
// =============================================
function hookSwiperSlideChange() {
    document.querySelectorAll('.diamond-swiper').forEach((swiperEl) => {
        const swiper = swiperEl.swiper;
        if (!swiper) return;

        swiper.on('slideChange', () => {
            setTimeout(fix360IframeDisplay, 200);
        });
    });
}


// =============================================
// Init
// =============================================
function init() {
    fix360IframeDisplay();
    setTimeout(hookSwiperSlideChange, 1500);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}